import {
  getTicketMessageListQueryKey,
  ticketMessageList,
  useTicketCreate,
  useTicketGet,
  useTicketGetSuspense,
  useTicketList,
  useTicketListSuspense,
  useTicketMessageCreate,
  useTicketMessageList,
  useTicketMessageListSuspense,
  useTicketMessageMarkAllAsRead,
  useTicketUpdate,
  useTicketUpdateContractor,
} from "@/api/generated/endpoints/api"
import {
  ticketCreateBody,
  ticketMessageCreateBody,
  ticketUpdateBody,
  ticketUpdateContractorBody,
} from "@/api/generated/schemas/api.zod"

export * as TicketModels from "./models"
export * from "./models"

export const ticketApi = {
  // Query Hooks
  useTicketList,
  useTicketListSuspense,
  useTicketGet,
  useTicketGetSuspense,
  useTicketMessageList,
  useTicketMessageListSuspense,

  // Query Keys
  getTicketMessageListQueryKey,

  // Raw API functions
  ticketMessageList,

  // Mutation Hooks
  useTicketCreate,
  useTicketUpdate,
  useTicketUpdateContractor,
  useTicketMessageCreate,
  useTicketMessageMarkAllAsRead,
}

export const ticketSchemas = {
  ticketCreateBody,
  ticketUpdateBody,
  ticketUpdateContractorBody,
  ticketMessageCreateBody,
}
